import vtkXMLImageDataReader from './XMLImageDataReader';
import vtkXMLPolyDataReader from './XMLPolyDataReader';
import vtkXMLReader from './XMLReader';

export default {
  vtkXMLImageDataReader,
  vtkXMLPolyDataReader,
  vtkXMLReader,
};
